<template>
  <div class="w-full">
    <label class="inline-flex items-center">
      <input
        :checked="value"
        @change="input"
        :id="id"
        type="checkbox"
        class="form-checkbox text-green-500"
        :class="[error ? inputError : inputValid]"
      />
      <span class="ml-2" :class="[error ? labelError : labelValid]">
        <slot></slot>
      </span>
    </label>
    <div v-if="info && !error" class="w-full text-sm text-blue-800 mt-1 mb-0">{{ info }}</div>
    <div v-if="error" class="w-full text-sm text-red-800 mt-1 mb-0">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    value: {
      required: true
    },
    id: {
      required: true
    },
    errors: {
      default: null
    },
    info: {
      default: null
    },
    disabled: {
      default: false
    },
    textColor: {
      default: 'green'
    }
  },
  data() {
    return {
      labelValid: "text-" + this.textColor + "-800",
      labelError: "text-red-800",
      inputValid: "text-" + this.textColor + "-500",
      inputError: "text-red-500"
    }
  },
  computed: {
    error() {
      if (!this.errors) return false
      return this.errors.has(this.id) ? this.errors.first(this.id) : false
    }
  },
  methods: {
    input(e) {
      if (this.errors) this.errors.clear(this.id)
      this.$emit("input", e.target.checked)
    }
  }
}
</script>

<style scoped lang="scss">
input[disabled] {
  @apply cursor-not-allowed opacity-50;
}
</style>
